import {
	config
} from '../config'

const getCacheKey = (key) => {
	return `${config.cache_prefix}${key}`
}
const getDataSet = (event, key) => {
	return event.currentTarget.getAttribute(`data-${key}`)
}
const arrGetSomeKeys = (arr, keys, hasKey = true) => {
	let res = [];
	for (let val of keys) {
		if (arr[val]) {
			if (hasKey) {
				res[val] = arr[val];
			} else {
				res.push(arr[val]);
			}
		}
	}
	return res;
}
const objGetSomeKeys = (arr, keys, hasKey = true) => {
	let res = hasKey ? {} : [];
	for (let val of keys) {
		if (arr[val]) {
			if (hasKey) {
				res[val] = arr[val]; //= =>obj
			} else {
				res.push(arr[val]); //= =》arr
			}
		}
	}
	return res;
}
const getArrIndexByKey = (arr, keyName, keyVal) => {
	for (let [index, value] of arr.entries()) {
		if (value[keyName] == keyVal) {
			return index;
		}
	}
	return -1;
}
const getArrColumn = (orginArr, $mxColumnKey) => {
	let datas = []
	for (let obj of orginArr) {
		datas.push(obj[$mxColumnKey])
	}
	return datas
}
const cloneDeep = (srcObject) => {
	return JSON.parse(JSON.stringify(srcObject)) // 仅限于 但这种方法要求对象中的属性值不能是函数。
}
export {
	getCacheKey,
	getDataSet,
	arrGetSomeKeys,
	objGetSomeKeys,
	getArrIndexByKey,
	getArrColumn,
	cloneDeep
}
